import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinvimannagar() {



const cardData = {
  keyword: "Cab Service in Viman Nagar",
  heading: "Lotus Cab: Cab Service in Viman Nagar",

  headingDescription:
    "Lotus Cab provides professional, affordable, and highly reliable Cab Service in Viman Nagar for airport transfers, corporate travel, family outings, daily commuting, and long-distance outstation trips. Viman Nagar is one of Pune’s prime residential and commercial areas, located close to Pune International Airport and major IT parks, making timely and comfortable transportation extremely important. Whether you require an AC sedan for daily office travel, a spacious SUV for family trips, a luxury car for executive meetings, or a mini bus for group events, our fleet is fully equipped to meet every requirement. All vehicles are regularly serviced, GPS-enabled, thoroughly sanitized, and maintained for smooth city as well as highway travel. We offer transparent per-kilometer pricing with no hidden charges and flexible one-way, round-trip, and hourly rental options. Our background-verified chauffeurs ensure punctual pickup, safe driving, and professional behavior. With 24/7 customer support and instant online booking, Lotus Cab guarantees a smooth, comfortable, and stress-free taxi experience in Viman Nagar.",

  top: "Top Places to Visit in Pune from Viman Nagar with Lotus Cab",

  topPlaces: [
    {
      title: "Phoenix Marketcity",
      description:
        "Phoenix Marketcity is one of the largest shopping and entertainment destinations near Viman Nagar. It offers premium shopping brands, fine dining restaurants, multiplex cinemas, and entertainment zones. Booking a cab from Viman Nagar ensures quick and comfortable access without parking hassles. AC sedans are ideal for small family visits, while SUVs are perfect for group outings. Our drivers ensure convenient drop and pickup at mall entrances. Flexible waiting options allow relaxed shopping. Evening visits become stress-free with chauffeur-driven service. Lotus Cab ensures smooth city connectivity."
    },
    {
      title: "Pune International Airport",
      description:
        "Viman Nagar is located very close to Pune International Airport, making airport transfers one of the most important travel needs in the area. Our cab service ensures timely pickup and drop with flight tracking support. AC vehicles provide comfortable travel with ample luggage space. Professional chauffeurs assist with baggage handling. Corporate travelers rely on our punctual service for business trips. Same-day airport return packages are available. GPS-enabled vehicles ensure safe and reliable transfers."
    },
    {
      title: "Aga Khan Palace",
      description:
        "Aga Khan Palace is a historic landmark associated with India’s freedom movement. Located near Viman Nagar, it is a popular destination for families and tourists. Our taxi service ensures smooth city travel without traffic stress. AC comfort enhances the sightseeing experience during warm days. Drivers are familiar with city routes to avoid congestion. Flexible waiting time makes visits comfortable. Ideal for educational and heritage tours."
    },
    {
      title: "Koregaon Park",
      description:
        "Koregaon Park is known for its upscale cafes, restaurants, and nightlife. Booking a cab from Viman Nagar ensures safe and convenient evening travel. Chauffeur-driven service avoids parking difficulties. Ideal for corporate dinners and social outings."
    },
    {
      title: "Bund Garden",
      description:
        "A peaceful green space ideal for relaxation and family visits. Comfortable AC taxi service ensures relaxed city travel from Viman Nagar."
    },
    {
      title: "Shaniwar Wada",
      description:
        "Historic Maratha fort located in central Pune. Reliable cab service ensures smooth travel even during peak hours."
    },
    {
      title: "Khadakwasla Dam",
      description:
        "Popular weekend getaway for families. SUV options are ideal for comfortable round-trip travel."
    },
    {
      title: "Lonavala",
      description:
        "Scenic expressway destination ideal for weekend trips. AC sedan and SUV cabs provide smooth highway travel from Viman Nagar."
    }
  ],

  services: [
    {
      name: "Viman Nagar Cab Service",
      description:
        "Our Viman Nagar cab service provides dependable transportation for airport transfers, corporate travel, family outings, and outstation journeys. Customers can choose from AC sedans, spacious SUVs, luxury cars, and mini buses based on their travel needs. Vehicles are regularly maintained and sanitized for hygiene and safety. Professional chauffeurs ensure punctual pickup and disciplined driving. Transparent fare structure eliminates hidden costs. Ideal for residents, corporate employees, and tourists. Flexible one-way and round-trip packages available. Lotus Cab guarantees smooth and comfortable travel."
    },
    {
      name: "AC Cab Viman Nagar",
      description:
        "Fully air-conditioned cabs available for comfortable travel during all seasons. Ideal for office commuting and airport transfers. Clean interiors and professional drivers ensure a relaxed ride. Suitable for short and long city trips."
    },
    {
      name: "SUV Cab Viman Nagar",
      description:
        "Spacious SUV taxis ideal for families and group travel. Comfortable seating and ample luggage space ensure stress-free travel."
    },
    {
      name: "Luxury Cab Viman Nagar",
      description:
        "Premium luxury vehicles for executive meetings and VIP guests. Elegant interiors and professional chauffeur service enhance travel comfort."
    },
    {
      name: "Airport Pickup Viman Nagar",
      description:
        "Reliable airport pickup service with real-time flight tracking. Timely arrival and luggage assistance guaranteed."
    },
    {
      name: "Outstation Cab Viman Nagar",
      description:
        "Comfortable long-distance taxi service from Viman Nagar to Mumbai, Nashik, Mahabaleshwar, and other destinations."
    },
    {
      name: "Corporate Cab Viman Nagar",
      description:
        "Dedicated corporate taxi solutions for IT parks and business meetings. Professional drivers ensure punctual service."
    },
    {
      name: "Online Cab Booking Viman Nagar",
      description:
        "Instant online booking with transparent fare details and 24/7 customer support."
    }
  ],

  tableData: [
    ["Viman Nagar Cab Service", "AC Cab Viman Nagar"],
    ["Sedan Cab Viman Nagar", "SUV Cab Viman Nagar"],
    ["Luxury Cab Viman Nagar", "Corporate Cab Viman Nagar"],
    ["Family Trip Cab Viman Nagar", "Airport Pickup Viman Nagar"],
    ["Airport Drop Viman Nagar", "Online Cab Booking Viman Nagar"],
    ["One Way Cab Viman Nagar", "Round Trip Cab Viman Nagar"],
    ["Mini Bus Viman Nagar", "Chauffeur Driven Cab Viman Nagar"],
    ["Budget Cab Viman Nagar", "Same Day Cab Viman Nagar"],
    ["Outstation Cab Viman Nagar", "Per Km Rate Cab Viman Nagar"],
    ["Weekend Trip Cab Viman Nagar", "Best Cab Service Viman Nagar"]
  ],

  whychoose: [
    { WhyChooseheading: "Fast Airport Connectivity", WhyChoosedescription: "Located near airport, ensuring quick and reliable transfers." },
    { WhyChooseheading: "Transparent Pricing", WhyChoosedescription: "Clear per-kilometer fare breakdown without hidden charges." },
    { WhyChooseheading: "Professional Drivers", WhyChoosedescription: "Background-verified chauffeurs trained for city and highway travel." },
    { WhyChooseheading: "Wide Fleet Options", WhyChoosedescription: "Sedans, SUVs, luxury cars, and mini buses available." },
    { WhyChooseheading: "Corporate Travel Expertise", WhyChoosedescription: "Dedicated service for IT and business professionals." },
    { WhyChooseheading: "Clean & Sanitized Vehicles", WhyChoosedescription: "Regular vehicle maintenance and hygiene checks." },
    { WhyChooseheading: "Flexible Packages", WhyChoosedescription: "One-way, round-trip, and hourly rental options available." },
    { WhyChooseheading: "24/7 Support", WhyChoosedescription: "Round-the-clock booking and customer assistance." }
  ]
};

const faqData = [
  { question: "Do you provide airport pickup in Viman Nagar?", answer: "Yes, we provide timely airport pickup and drop with flight tracking support." },
  { question: "Are AC vehicles available?", answer: "Yes, all vehicles are fully air-conditioned." },
  { question: "Is online booking available?", answer: "Yes, instant booking is available with confirmation." },
  { question: "Do you offer outstation travel?", answer: "Yes, long-distance taxi services are available." },
  { question: "Are drivers verified?", answer: "Yes, chauffeurs are background-verified and trained." },
  { question: "Is per km pricing transparent?", answer: "Yes, complete fare details are shared before booking." },
  { question: "Are SUVs available?", answer: "Yes, spacious SUV options are available." },
  { question: "Is mini bus service available?", answer: "Yes, mini bus options are available for group bookings." },
  { question: "Is 24/7 support available?", answer: "Yes, support is available round-the-clock." },
  { question: "Do you provide corporate cab service?", answer: "Yes, corporate travel solutions are available." }
];

const testimonials = [
  { id: 1, name: "Mr. Rohan Kulkarni", feedback: "Very punctual airport pickup from Viman Nagar. Clean vehicle and professional driver. Excellent service.", rating: 5 },
  { id: 2, name: "Ms. Priya Mehta", feedback: "Booked SUV for family trip. Comfortable ride and smooth experience.", rating: 5 },
  { id: 3, name: "Corporate Client", feedback: "Reliable corporate taxi service for office travel. Transparent billing and punctual drivers.", rating: 5 },
  { id: 4, name: "Mr. Aniket Joshi", feedback: "Used outstation cab from Viman Nagar. Great highway driving and reasonable pricing.", rating: 5 },
  { id: 5, name: "Mrs. Neha Shah", feedback: "Quick online booking and professional service. Highly recommended.", rating: 5 }
];






































































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Viman Nagar",
  "image": "https://lotuscab.com/assets/images/viman-nagar-cab.jpg",
  "description": "Book reliable Cab Service in Viman Nagar with Lotus Cab. Choose from AC, sedan, SUV, luxury cabs, Mini Bus, or chauffeur-driven rides for one-way, round trips, family trips, corporate travel, airport transfers, weekend trips, and outstation trips. Affordable per km rates and same-day options available.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "620"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "150",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/viman-nagar-cab-service"
  }
};






  return (
    <div>
      

<Helmet>
  <title>Cab Service in Viman Nagar | Lotus Cab | Call +91 8767592195</title>
  <meta 
    name="description" 
    content="Book reliable Cab Service in Viman Nagar with Lotus Cab. AC, sedan, SUV, luxury cabs, Mini Bus & chauffeur-driven rides for one-way, round trips, family trips, corporate travel, airport transfers, weekend & outstation trips. Affordable per km rates. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Viman Nagar Cab Service, AC Cab Viman Nagar, Sedan Cab Viman Nagar, SUV Cab Viman Nagar, Luxury Cab Viman Nagar, Corporate Cab Viman Nagar, Family Trip Cab Viman Nagar, Airport Pickup Viman Nagar, Airport Drop Viman Nagar, Online Cab Booking Viman Nagar, One Way Cab Viman Nagar, Round Trip Cab Viman Nagar, Mini Bus Viman Nagar, Chauffeur Driven Cab Viman Nagar, Budget Cab Viman Nagar, Same Day Cab Viman Nagar, Outstation Cab Viman Nagar, Per Km Rate Cab Viman Nagar, Weekend Trip Cab Viman Nagar, Best Cab Service Viman Nagar" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/73.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinvimannagar;